import useStarterEnabled from '~pricing/hooks/useStarterEnabled';
import { EXPERIMENT_IDENTIFIERS } from '~server/routes/Pricing/experimentsConfig';

import { getPackageSetBasedOnPath } from '~pricing/lib/lib-helpers';
import { PackageSet, PackageType } from '~shared/types/pricing/package';
import { GROW_2792_PACKAGES, GROW_2792_PACKAGES_T3 } from '../lib/constants';
import useExperimentAssignment from './useExperimentAssignment';

export default function usePackageSet(canonicalPath: string): { packageSet: PackageSet } {
  const { isStarterEnabled } = useStarterEnabled();
  const { experience, isPnPRefresh } = useExperimentAssignment();
  const isEducational = canonicalPath === PackageType.Educational;

  function determinePackageSet(): PackageSet {
    if (!isEducational && isPnPRefresh) {
      if (experience === EXPERIMENT_IDENTIFIERS.GROW_2792.treatment3) {
        return GROW_2792_PACKAGES_T3;
      }
      return GROW_2792_PACKAGES;
    }

    return getPackageSetBasedOnPath(canonicalPath, isStarterEnabled);
  }

  return {
    packageSet: determinePackageSet(),
  };
}
